import { getSchedulerDataServicesRepair } from "../services";
import { filteredServicesComponents } from "../filteredServicesComponent"

export function heatingCoolingRepair (){
  
  let servicesStart =[
  {
    id: "No Cooling",
    label: <>No Cooling</>,
    data: [
      [
        {
          name: "equipmentType",
          question: "What kind of equipment do you have?",
          answers: [
            {
              id: "Outdoor Mist System",
              label: <>Outdoor Mist System</>,
              value: "Outdoor Mist Cooling System",
              jobType: "Outdoor Mist Cooling System",
            },
            {
              id: "Swamp Cooler",
              label: <>Swamp Cooler</>,
              value: "Swamp Cooler",
              jobType: "Swamp Cooler",
            },
            {
              id: "Heat Pump",
              label: <>Heat Pump</>,
              value: "Heat Pump",
              jobType: "Heat Pump",
            },
            {
              id: "Geo-Thermal",
              label: <>Geo-Thermal</>,
              value: "Geo Thermal Cooling System",
              jobType: "Geo Thermal Cooling System",
            },
            {
              id: "Mini-Split/Ductless",
              label: <>Mini-Split/Ductless</>,
              value: "Ductless Mini-Split A/C",
              jobType: "Ductless Mini-Split A/C",
            },
            {
              id: "Central A/C",
              label: <>Central A/C</>,
              value: "Central A/C",
              jobType: "Central A/C",
            },
            {
              id: "Whole House Fan",
              label: <>Whole House Fan</>,
              value: "Whole House Fan",
              jobType: "Whole House Fan",
            },
            {
              id: "Window A/C Unit",
              label: <>Window A/C Unit</>,
              value: "Window A/C Unit",
              jobType: "Window A/C Unit",
            },
            {
              id: "Unsure",
              label: <>Unsure</>,
              value: "HVAC: Unsure Equipment",
              jobType: "HVAC: Unsure Equipment",
            },
          ],
        },
        {
          name: "equipmentAge",
          question: "How old is your equipment?",
          answers: [
            {
              id: "0-5 Years",
              label: <>0-5 Years</>,
              value: "0-5 Years",
            },
            {
              id: "6-10 Years",
              label: <>6-10 Years</>,
              value: "6-10 Years",
            },
            {
              id: "11+ Years",
              label: <>11+ Years</>,
              value: "11+ Years",
            },
            {
              id: "Not Sure",
              label: <>Not Sure</>,
              value: "Not Sure",
            },
          ],
        },
      ],
    ],
  },
  {
    id: "No Heating",
    label: <>No Heating</>,
    data: [
      [
        {
          name: "equipmentType",
          question: "What kind of equipment do you have?",
          answers: [
            {
              id: "Oil Boiler",
              label: <>Oil Boiler</>,
              value: "Oil Boiler",
              jobType: "Oil Boiler",
              remType: "repair"
            },
            {
              id: "Heat Pump",
              label: <>Heat Pump</>,
              value: "Heat Pump",
              jobType: "Heat Pump",
              remType: "repair"
            },
            {
              id: "Geo-Thermal",
              label: <>Geo-Thermal</>,
              value: "Geo-Thermal",
              jobType: "Geo Thermal Heating System",
              remType: "repair"
            },
            {
              id: "Mini-Split/Ductless",
              label: <>Mini-Split/Ductless</>,
              value: "Mini-Split/Ductless",
              jobType: "Ductless Mini-Split A/C",
              remType: "repair"
            },
            {
              id: "Gas Furnace",
              label: <>Gas Furnace</>,
              value: "Gas Furnace",
              jobType: "Gas Furnace",
              remType: "repair"
            },
            {
              id: "Oil Furnace",
              label: <>Oil Furnace</>,
              value: "Oil Furnace",
              jobType: "Oil Furnace",
              remType: "repair"
            },
            {
              id: "Gas Boiler",
              label: <>Gas Boiler</>,
              value: "Gas Boiler",
              jobType: "Gas Boiler",
              remType: "repair"
            },
            {
              id: "Electric Wall Heater",
              label: <>Electric Wall Heater</>,
              value: "Electrical Wall Heater",
              jobType: "Electrical Wall Heater",
              remType: "repair"
            },
            {
              id: "Electric Furnace",
              label: <>Electric Furnace</>,
              value: "Electric Furnace",
              jobType: "Electric Furnace",
              remType: "repair"
            },
            {
              id: "Electric Boiler",
              label: <>Electric Boiler</>,
              value: "Electric Boiler",
              jobType: "Electric Boiler",
              remType: "repair"
            },
            {
              id: "Radiant Floor Heater",
              label: <>Radiant Floor Heater</>,
              value: "Radiant Floor Heating System",
              jobType: "Radiant Floor Heating System",
              remType: "repair"
            },
            {
              id: "Radiant Panel Heater",
              label: <>Radiant Panel Heater</>,
              value: "Radiant Panel Heating Units",
              jobType: "Radiant Panel Heating Units",
              remType: "repair"
            },
            {
              id: "Unsure",
              label: <>Unsure</>,
              value: "HVAC: Unsure Equipment",
              jobType: "HVAC: Unsure Equipment",
              remType: "repair"
            },
          ],
        },
        {
          name: "equipmentAge",
          question: "How old is your equipment?",
          answers: [
            {
              id: "0-5 Years",
              label: <>0-5 Years</>,
              value: "0-5 Years",
            },
            {
              id: "6-10 Years",
              label: <>6-10 Years</>,
              value: "6-10 Years",
            },
            {
              id: "11+ Years",
              label: <>11+ Years</>,
              value: "11+ Years",
            },
            {
              id: "Not Sure",
              label: <>Not Sure</>,
              value: "Not Sure",
            },
          ],
        },
      ],
    ],
  },
  {
    id: "Other",
    label: <>Other</>,
    data: [
      [
        {
          name: "equipmentType",
          question: "What kind of equipment do you have?",
          answers: [
            {
              id: "Oil Boiler",
              label: <>Oil Boiler</>,
              value: "Oil Boiler",
              jobType: "Oil Boiler",
              remType: "repair"
            },
            {
              id: "Heat Pump",
              label: <>Heat Pump</>,
              value: "Heat Pump",
              jobType: "Heat Pump",
              remType: "repair"
            },
            {
              id: "Geo-Thermal Cooling",
              label: <>Geo-Thermal Cooling</>,
              value: "Geo Thermal Cooling System",
              jobType: "Geo Thermal Cooling System",
              remType: "repair"
            },
            {
              id: "Geo-Thermal Heating",
              label: <>Geo-Thermal Heating</>,
              value: "Geo Thermal Heating System",
              jobType: "Geo Thermal Heating System",
              remType: "repair"
            },
            {
              id: "Mini-Split/Ductless Heating",
              label: <>Mini-Split/Ductless Heating</>,
              value: "Mini-Split/Ductless Heating",
              jobType: "Ductless Mini-Split Heating",
              remType: "repair"
            },
            {
              id: "Mini-Split/Ductless A/C",
              label: <>Mini-Split/Ductless A/C</>,
              value: "Mini-Split/Ductless A/C",
              jobType: "Ductless Mini-Split A/C",
              remType: "repair"
            },
            {
              id: "Gas Furnace",
              label: <>Gas Furnace</>,
              value: "Gas Furnace",
              jobType: "Gas Furnace",
              remType: "repair"
            },
            {
              id: "Oil Furnace",
              label: <>Oil Furnace</>,
              value: "Oil Furnace",
              jobType: "Oil Furnace",
              remType: "repair"
            },
            {
              id: "Gas Boiler",
              label: <>Gas Boiler</>,
              value: "Gas Boiler",
              jobType: "Gas Boiler",
              remType: "repair"
            },
            {
              id: "Electrical Wall Heater",
              label: <>Electric Wall Heater</>,
              value: "Electrical Wall Heater",
              jobType: "Electrical Wall Heater",
              remType: "repair"
            },
            {
              id: "Electric Furnace",
              label: <>Electric Furnace</>,
              value: "Electric Furnace",
              jobType: "Electric Furnace",
              remType: "repair"
            },
            {
              id: "Electric Boiler",
              label: <>Electric Boiler</>,
              value: "Electric Boiler",
              jobType: "Electric Boiler",
              remType: "repair"
            },
            {
              id: "Radiant Floor Heater",
              label: <>Radiant Floor Heater</>,
              value: "Radiant Floor Heater",
              jobType: "Radiant Floor Heating System",
              remType: "repair"
            },
            {
              id: "Radiant Panel Heater",
              label: <>Radiant Panel Heater</>,
              value: "Radiant Panel Heater",
              jobType: "Radiant Panel Heating Units",
              remType: "repair"
            },
            {
              id: "Unsure",
              label: <>Unsure</>,
              value: "Unsure",
              jobType: "HVAC: Other Equipment",
              remType: "repair"
            },
          ],
        },
        {
          name: "equipmentAge",
          question: "How old is your equipment?",
          answers: [
            {
              id: "0-5 Years",
              label: <>0-5 Years</>,
              value: "0-5 Years",
            },
            {
              id: "6-10 Years",
              label: <>6-10 Years</>,
              value: "6-10 Years",
            },
            {
              id: "11+ Years",
              label: <>11+ Years</>,
              value: "11+ Years",
            },
            {
              id: "Not Sure",
              label: <>Not Sure</>,
              value: "Not Sure",
            },
          ],
        },
      ],
    ],
  },
  {
    id: "Water Heaters",
    label: <>Water Heaters</>,
    data: [
      [
        {
          name: "equipmentType",
          question: "What kind of water heater do you have?",
          answers: [
            {
              id: "Regular Tank",
              label: <>Regular Tank</>,
              value: "Regular Tank",
              jobType: "Tankless Water Heater: Non-Member",
              remType: "repair"
            },
            {
              id: "Tankless",
              label: <>Tankless</>,
              value: "Tankless Water Heater",
              jobType: "Tankless Water Heater: Non-Member",
              remType: "repair"
            },
          ],
        },
        {
          name: "equipmentAge",
          question: "How old is your equipment?",
          answers: [
            {
              id: "0-5 Years",
              label: <>0-5 Years</>,
              value: "0-5 Years",
            },
            {
              id: "6-10 Years",
              label: <>6-10 Years</>,
              value: "6-10 Years",
            },
            {
              id: "11+ Years",
              label: <>11+ Years</>,
              value: "11+ Years",
            },
            {
              id: "Not Sure",
              label: <>Not Sure</>,
              value: "Not Sure",
            },
          ],
        },
      ],
    ],
  },
];

const jobTypeFilter = getSchedulerDataServicesRepair// Replace with the desired job type to filter

return filteredServicesComponents(servicesStart, jobTypeFilter);
}